"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortfolioCellModel = /** @class */ (function () {
    function PortfolioCellModel(_metaField, _fieldValue, _isNameField) {
        this._metaField = _metaField;
        this._fieldValue = _fieldValue;
        this._isNameField = _isNameField;
    }
    Object.defineProperty(PortfolioCellModel.prototype, "compoundCategorySystemName", {
        get: function () {
            return this._metaField.getCompoundCategorySystemName();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioCellModel.prototype, "fieldType", {
        get: function () {
            return this._metaField.getType();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioCellModel.prototype, "fieldValue", {
        get: function () {
            return this._fieldValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioCellModel.prototype, "isNameField", {
        get: function () {
            return this._isNameField;
        },
        enumerable: true,
        configurable: true
    });
    return PortfolioCellModel;
}());
exports.PortfolioCellModel = PortfolioCellModel;
//# sourceMappingURL=portfolio-cell.model.js.map